import { Auth0Provider, type AppState } from "@auth0/auth0-react";
import type { ReactNode } from "react";
import { appConfig } from "@/config";
import { AUTH_DISABLED } from "./devMode";

export function AuthProvider({
  children,
  onRedirectCallback,
}: {
  children: ReactNode;
  onRedirectCallback?: (appState?: AppState) => void;
}) {
  if (AUTH_DISABLED) {
    return <>{children}</>;
  }

  // No audience: the API validates the ID token (audience = this client ID),
  // matching gft-product-service / gft-cohort-service.
  return (
    <Auth0Provider
      domain={appConfig.auth0Domain}
      clientId={appConfig.auth0ClientId}
      cacheLocation="localstorage"
      useRefreshTokens
      onRedirectCallback={onRedirectCallback}
      authorizationParams={{
        redirect_uri: window.location.origin,
        scope: "openid profile email",
      }}
    >
      {children}
    </Auth0Provider>
  );
}
